import { useUpsellModalStore, useUpsellTriggerStore } from './useUpsellModalStore';

export const resetUpsellSession = () => {
  useUpsellModalStore.getState().close();
  useUpsellTriggerStore.setState({ homeVisits: 0 });
};
